import { url } from '@/config'; // var request = window.axios;

import request from '@/router/axios';
export var getList = function getList(params) {
  return request({
    url: url + '/visual/list',
    method: 'get',
    params: params
  });
};
export var copyObj = function copyObj(id) {
  return request({
    url: url + '/visual/copy',
    method: 'post',
    params: {
      id: id
    }
  });
};
export var getCategory = function getCategory(params) {
  return request({
    url: url + '/category/list',
    method: 'get',
    params: params
  });
};
export var getObj = function getObj(id) {
  return request({
    url: url + '/visual/detail',
    method: 'get',
    params: {
      id: id
    }
  });
};
export var uploadImg = function uploadImg(file) {
  return request({
    url: url + '/visual/put-file',
    method: 'post',
    data: 'file=' + file,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};
export var addObj = function addObj(data) {
  return request({
    url: url + '/visual/save',
    method: 'post',
    data: {
      visual: {
        password: data.password,
        category: data.category,
        status: data.status,
        title: data.title
      },
      config: {
        detail: JSON.stringify({
          name: data.title,
          width: data.width,
          height: data.height,
          scale: 1,
          backgroundImage: '/img/bg/bg1.png',
          url: '',
          mark: {},
          gradeShow: false,
          gradeLen: 30
        }),
        component: '[]'
      }
    }
  });
};
export var updateComponent = function updateComponent(data) {
  return request({
    url: url + '/visual/update',
    method: 'post',
    data: data
  });
};
export var updateObj = function updateObj(data) {
  return request({
    url: url + '/visual/update',
    method: 'post',
    data: {
      "visual": {
        "id": data.id,
        "password": data.password,
        "category": data.category,
        "status": data.status,
        "title": data.title
      }
    }
  });
};
export var delObj = function delObj(id) {
  return request({
    url: url + '/visual/remove',
    method: 'post',
    params: {
      ids: id
    }
  });
};